import { IColumnDefinition } from '@common/models/column-definition';
import { createAction, props } from '@ngrx/store';
import { DashboardItem } from '@dashboards/models/dashboard-item';
import { IContext } from '@context/models/context';
import { IResizedColumn } from '@common/models/table';

export const load = createAction(
    '[Payment To You Table Columns] Load',
    props<{ widget: DashboardItem }>()
);
export const loadComplete = createAction(
    '[Payment To You Table Columns] Load Complete',
    props<{
        payload: Array<IColumnDefinition>,
        widget: DashboardItem }>()
);
export const loadAll = createAction(
    '[Payment To You Table Columns] Load All'
);
export const loadAllComplete = createAction(
    '[Payment To You Table Columns] Load All Complete',
    props<{ payload: Array<IColumnDefinition> }>()
);
export const updateMojoColumn = createAction(
    '[Payment To You Table Columns] Update Mojo Columns',
    props<{ context: IContext, columnDefinition: IColumnDefinition[], widget: DashboardItem }>()
);
export const updateMfsColumn = createAction(
    '[Payment To You Table Columns] Update MFS Columns',
    props<{ accountRef: number, columnDefinition: IColumnDefinition[], widget: DashboardItem }>()
);
export const resetToMojoDefault = createAction(
    '[Payment To You Table Columns] Reset To Mojo Defaults',
    props<{ context: IContext, widget: DashboardItem }>()
);
export const resetToMfsDefault = createAction(
    '[Payment To You Table Columns] Reset To MFS Defaults',
    props<{ accountRef: number, widget: DashboardItem }>()
);
export const updateMojoColumnComplete = createAction(
    '[Payment To You Table Columns] Update Mojo Columns Complete',
    props<{ context: IContext, widget: DashboardItem }>()
);
export const updateMfsColumnComplete = createAction(
    '[Payment To You Table Columns] Update MFS Columns Complete',
    props<{ accountRef: number, widget: DashboardItem }>()
);
export const resizeColumns = createAction(
    '[Payment To You Table Columns] Resize Columns',
    props<{ payload: IResizedColumn, widget: DashboardItem }>()
);
export const resizeColumnsComplete = createAction(
    '[Payment To You Table Columns] Resize Columns Complete',
    props<{ widget: DashboardItem }>()
);
export const reorderColumns = createAction(
    '[Payment To You Table Columns] Reorder Columns',
    props<{ payload: string[], widget: DashboardItem }>()
);
export const reorderColumnsComplete = createAction(
    '[Payment To You Table Columns] Reorder Columns Complete',
    props<{ widget: DashboardItem }>()
);
